import React, { useEffect, useState } from 'react';
import SweetAlert2, { withSwal } from 'react-sweetalert2';

import { selectDocuments } from '../redux/slices/documentSlice';
import { selectProfile } from '../redux/slices/profileSlice';
import { selectSession } from '../redux/slices/sessionSlice';
import { selectSignature } from '../redux/slices/signatureSlice';
import { selectStage } from '../redux/slices/stageSlice';
import Swal from 'sweetalert2';
import { useAppSelector } from '../redux/hook';
import { useTranslation } from 'react-i18next';

// import { toast } from 'react-toastify';

function isMagicTokenExpiredOrUnauthorized(error: any): boolean {
	if (!error) return false;
	const status = error?.status ?? error?.response?.status;
	const message = (error?.message ?? error?.error ?? '').toString();

	return (
		status === 401 ||
		status === 403 ||
		/magic\s*token/i.test(message) ||
		/invalid\s*token/i.test(message) ||
		/pre-?check-?in\s*link/i.test(message)
	);
}

export default function ToastContainerHome() {
	const { t } = useTranslation();
	const { error: documentError } = useAppSelector(selectDocuments);
	const { isReload } = useAppSelector(selectDocuments);
	const { error: profileError } = useAppSelector(selectProfile);
	const {
		loading,
		swal: dispToast,
		error: sessionError,
	} = useAppSelector(selectSession);
	const { error: signatureError } = useAppSelector(selectSignature);
	const { error: stageError } = useAppSelector(selectStage);
	// For loading toasts
	// useEffect(() => {
	// 	if (dispToast)
	// 		toast.info('Please wait while we process your information.', {
	// 			autoClose: false,
	// 			toastId: 'toast to wait for post requests!',
	// 		});
	// 	else {
	// 		toast.dismiss('toast to wait for post requests!');
	// 	}
	// }, [dispToast]);

	// For errors
	useEffect(() => {
		[
			documentError,
			profileError,
			sessionError,
			signatureError,
			stageError,
		].forEach((sliceError) => {
			try {
				Object.values(sliceError)?.forEach((error: any) => {
					console.log('error msgs--' + JSON.stringify(error));
					//if (error) toast.error(error.message);
					if (error) {
						if (isMagicTokenExpiredOrUnauthorized(error)) return;
						if (error.code == '404') {
							Swal.fire({
								// Use Swal.fire to show the alert
								//title: 'Invalid Document',
								text: t(error.message),
								icon: 'error',
							}).then(function () {
								console.log(error);
								//window.location.reload();
							});
						} else if (error.code == '301') {
							Swal.fire({
								// Use Swal.fire to show the alert
								//title: 'Invalid Request',
								text: t(error.message),
								icon: 'error',
								allowOutsideClick: false,
								showCloseButton: false,
								showCancelButton: false,
								showConfirmButton: false,
							});
						} else if (error.code == '105') {
							Swal.fire({
								// Use Swal.fire to show the alert
								//title: 'Invalid Request',
								title: t('Reservation not found'),
								text: t(
									'Unable to fetch the reservation. Please contact support or front desk.'
								),
								icon: 'error',
								allowOutsideClick: false,
								showCloseButton: false,
								showCancelButton: false,
								showConfirmButton: false,
							});
						} else if (error.message) {
							Swal.fire({
								// Use Swal.fire to show the alert
								//title: 'Invalid Request',
								text: t(error.message),
								icon: 'error',
							}).then(function () {
								console.log(error.message);
								window.location.reload();
								//window.location.reload();
							});
						}
					}
					//TODO: Check if this works. Written on expectations.
				});
			} catch (_) {
				//console.error(_);
				//toast.error('A fatal error has occurred.');
				Swal.fire({
					// Use Swal.fire to show the alert
					//title: 'Invalid Request',
					text: t('Please proceed to front desk for assistance'),
					icon: 'error',
				}).then(function () {
					window.location.reload();
					console.log('sliceError', sliceError);
					console.log('Some Error Occured--', _);
				});
			}
		});
	}, [documentError, profileError, sessionError, signatureError, stageError]);

	return (
		<>
			{/* <ToastContainer limit={3} theme="colored" /> */}
			{/* <SweetAlert2 /> */}
		</>
	);
}
